import Script from 'next/script'

import isEmpty from 'lodash/fp/isEmpty'

import { CRAZY_EGG_ACCOUNT_NUMBER } from '../constants'

type Props = {
  accountNumber?: string
}
export default function CrazyEgg({
  accountNumber = CRAZY_EGG_ACCOUNT_NUMBER,
}: Props) {
  if (isEmpty(accountNumber) || accountNumber.length !== 8) {
    return false
  }

  const firstAccountNumberPart = accountNumber.slice(0, 4)
  const secondAccountNumberPart = accountNumber.slice(4)

  return (
    <Script
      async
      src={`//script.crazyegg.com/pages/scripts/${firstAccountNumberPart}/${secondAccountNumberPart}.js`}
    />
  )
}
